import { useEffect } from 'react';

//This is a custom hook that will scroll to the first error in the form - Moe
function useScrollToError(errors: any) {
    useEffect(() => {
        if (errors) {
            const elements = Object.keys(errors)
                .map(name => document.getElementsByName(name)[0])
                .filter(el => !!el);
            elements.sort((a, b) => b.scrollHeight - a.scrollHeight);
            elements[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [errors]);
}

export default useScrollToError;
